module.exports = __webpack_public_path__ + "img/ss-everybody.f0438dd4.svg";